import PostalMime from 'postal-mime'

export type EmlContent = {
  subject: string | null
  html: string | null
}

// Parses a .eml file (raw RFC 822/5322 MIME source) entirely in-browser via
// postal-mime — deterministic MIME parsing, no model call. Only the html
// body and subject are surfaced: the subject is shown in the preview for
// context only and is never sent anywhere; the html body is what actually
// gets imported, through the exact same path as a pasted-HTML import.
export async function extractEmlContent(
  data: ArrayBuffer
): Promise<EmlContent> {
  const email = await PostalMime.parse(data)

  return {
    subject: email.subject?.trim() || null,
    html: email.html?.trim() || null,
  }
}
